import styled from 'react-emotion';
import { themeGet } from 'styled-system';
import { BaseButton } from '../buttons';
import { FlexCol } from '../misc';

export const Wrapper = styled(FlexCol)`
  max-width: 480px;
  margin: 0 auto;
  width: 100%;
  height: 100%;
  @media screen and (min-width: 40em) and (max-width: 52em), (min-width: 76em) {
    max-width: 580px;
    padding: ${themeGet('space.4')}px;
  }
`;

export const Container = styled('div');

export const FormContainer = styled('div')`
  position: relative;
  border-radius: 4px;
  border: 2px solid ${themeGet('colors.greyLight')};
  background: white;
  overflow-y: scroll;
  -ms-overflow-style: none;
  padding: ${themeGet('space.4')}px;
`;

export const WizardControls = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;

  button {
    margin: 0 12px;
  }
`;

export const ErrorText = styled('span')`
  padding: ${themeGet('space.2')}px ${themeGet('space.2')}px
    ${themeGet('space.1')}px ${themeGet('space.4')}px;
  font-weight: 300;
  color: ${themeGet('colors.orange')};
`;

export const SummaryToggle = styled(BaseButton)`
  border-top: 1px solid #f0f5fa;
  background: transparent;
  width: 100%;
  color: ${themeGet('colors.blueDarker')};
  font-weight: 400;
  font-size: 16px;
  text-decoration: underline;
  min-height: 40px;
  text-align: center;
  padding: ${themeGet('space.4')}px 0;
`;

export const Divider = styled('div')`
  width: 100%;
  height: 1px;
  border-bottom: 1px solid ${themeGet('colors.greyLight')};
  margin: 24px 0;
`;

export const SelectionHiglighter = styled('div')`
  border: ${props =>
    props.selected
      ? '0.7px solid rgba(218,225,231,1)'
      : '0.7px solid transparent'};
  box-shadow: 0 1px 3px 0 rgba(50, 50, 93, 0.15),
    0 4px 6px 0 rgba(112, 157, 199, 0.15);
  border-radius: 4px;
  transitions: border 0.15s linear;
`;



// WEBPACK FOOTER //
// ./src/components/orderformwizard/style.js